import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './AdminNavShortcut.scss';

// A real <a href> keeps native nav (keyboard, middle-click, hover preview, open-in-new-tab).
// The click dnd-kit fires after a drag is swallowed by AdminNav's container capture handler.
const AdminNavShortcut = ({ item, isActive, canDrag = true }) => {
  const { listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: item.key, disabled: !canDrag });
  const style = { transform: CSS.Transform.toString(transform), transition, opacity: isDragging ? 0.5 : 1 };

  // The `sortable` class sets touch-action: none; only apply it when dragging is enabled (desktop),
  // otherwise the chip would swallow the swipe-to-scroll gesture on touch.
  return (
    <a
      ref={setNodeRef}
      href={item.path}
      style={style}
      className={cn('nav-shortcut', { sortable: canDrag, active: isActive, dragging: isDragging })}
      {...(canDrag ? listeners : {})}
    >
      <FontAwesomeIcon icon={item.icon} className='shortcut-icon' />
      <span className='shortcut-label'>{item.label}</span>
    </a>
  );
};

AdminNavShortcut.propTypes = {
  item: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    icon: PropTypes.object.isRequired
  }).isRequired,
  isActive: PropTypes.bool,
  canDrag: PropTypes.bool
};

export default AdminNavShortcut;
